/* eslint-disable react-hooks/exhaustive-deps */
import Grid from '@mui/material/Grid';
import type { SwipeableDrawerProps } from '@mui/material/SwipeableDrawer';
import type { DialogProps } from '@mui/material/Dialog';
import { LinkProps as MUILinkProps } from '@mui/material/Link';
import { ListProps } from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Radio from '@mui/material/Radio';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import { DialogActionsProps } from '@mui/material/DialogActions';
import { DialogContentProps } from '@mui/material/DialogContent';
import { TypographyProps } from '@mui/material/Typography';
import { capitalize } from '@mui/material/utils';
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useEffect, useMemo, useState, KeyboardEvent, MouseEvent } from 'react'
import { FindButtonProps, FindFloatingButtonProps, FindMobileListItemButtonProps } from './FindDesignTypes'
import { useLayoutData } from '../../../utils/contexts/LayoutContext'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import CloseIcon from '@mui/icons-material/Close'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { ResultFilterModel, ResultFilterUIMode, ResultSordOrderModel } from '../../../client/swaggerClient'
import getFilterType, { MAX_FILTER_SHOW } from './FilterTypes/FilterType'
import { useRouter } from 'next/router'
import { PageType } from '../../../pages/_app'
import { FindFilterMobileBlockProps } from './Find.types'
import { useTranslation } from 'next-i18next'

const FindFilterMobileBlock = ({
  isMobile,
  colors,
  bazarItems,
  pageUrl,
  mmbr,
	isSkipResult,
  skipResult,
}: FindFilterMobileBlockProps) => {
  const { partnerSiteFull, templatePath } = useLayoutData()
  const router = useRouter()
  const { t } = useTranslation()

  const [sortOrderMobileOpen, setSortOrderMobileOpen] = useState<boolean>(false)
  const [sortOrder, setSortOrder] = useState<ResultSordOrderModel | undefined>(bazarItems?.sortOrders?.find((item) => item.isSelected))
  const [filterDialogMobileOpen, setFilterDialogMobileOpen] = useState<boolean>(false)
  const [filterMobileSubmenuOpen, setFilterMobileSubmenuOpen] = useState<ResultFilterModel | null>(null)
  const [filterMobileSubmenuDialogOpen, setFilterMobileSubmenuDialogOpen] = useState<ResultFilterModel | null>(null)
	const [lastUrl, setLastUrl] = useState<string | null>(null)
  const [filterMobileSubmenuDialogTitle, setFilterMobileSubmenuDialogTitle] = useState<string | null>(null)
  const [filterMobileSubmenuDialogSubtitle, setFilterMobileSubmenuDialogSubtitle] = useState<string | null>(null)

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath
  const type = templatePath

  const FindFloatingButton = useMemo(
    () =>
      dynamic<FindFloatingButtonProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindFloatingButton)
      ),
    [path]
  )
  const FindSwipeableDrawer = useMemo(
    () =>
      dynamic<SwipeableDrawerProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindSwipeableDrawer)
      ),
    [path]
  )
  const FindMobileListItemButton = useMemo(
    () =>
      dynamic<FindMobileListItemButtonProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindMobileListItemButton)
      ),
    [path]
  )
  const FindMobileLink = useMemo(
    () =>
      dynamic<MUILinkProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindMobileLink)
      ),
    [path]
  )
  const FindFullScreenDialog = useMemo(
    () =>
      dynamic<DialogProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindFullScreenDialog)
      ),
    [path]
  )
  const FindFullScreenDialogContent = useMemo(
    () =>
      dynamic<DialogContentProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindFullScreenDialogContent)
      ),
    [path]
  )
  const FindFullScreenDialogActions = useMemo(
    () =>
      dynamic<DialogActionsProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindFullScreenDialogActions)
      ),
    [path]
  )
  const FindMobileFilterList = useMemo(
    () =>
      dynamic<ListProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindMobileFilterList)
      ),
    [path]
  )
  const FindButton = useMemo(
    () =>
      dynamic<FindButtonProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindButton)
      ),
    [path]
  )
  const FindFilterTitle = useMemo(
    () =>
      dynamic<TypographyProps>(() =>
        import(`../../../design/${path}/_findDesign/Design`).then(style => style.FindFilterTitle)
      ),
    [path]
  )

  useEffect(() => {
    handleCloseAll()
  }, [isMobile])

  useEffect(() => {
    setTimeout(() => {
      setSortOrderMobileOpen(false)
    }, 500)
  }, [bazarItems?.sortOrders])

  const toggleSortOrder = (open: boolean) => (event: KeyboardEvent | MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as KeyboardEvent).key === 'Tab' || (event as KeyboardEvent).key === 'Shift')
    ) {
      return
    }
    setSortOrderMobileOpen(open)
  }

  const toggleFilters = (open: boolean) => {
		if (open) { setLastUrl(router.asPath) } else { setLastUrl(null) }
    skipResult(open)
    setFilterDialogMobileOpen(open)
  }

  const handleFilterMobileSubmenu = (filters: ResultFilterModel) => {
    const newDialog = (filters?.items?.length as number) > MAX_FILTER_SHOW
    const uiMode = filters?.uiMode

    if (
      newDialog ||
      uiMode === ResultFilterUIMode.FindQuery ||
      uiMode === ResultFilterUIMode.LongInterval ||
      uiMode === ResultFilterUIMode.DropDown ||
      uiMode === ResultFilterUIMode.SliderIntervalInteger ||
      uiMode === ResultFilterUIMode.SliderIntevalFloat ||
      uiMode === ResultFilterUIMode.IntervalDropDown
    ) {
      setFilterMobileSubmenuOpen(null)
      setFilterMobileSubmenuDialogOpen(filters)
      setFilterMobileSubmenuDialogTitle(filters?.title as string)
      setFilterMobileSubmenuDialogSubtitle(filters?.subtitle as string)
    } else {
      setFilterMobileSubmenuOpen(prevOpen => {
        if (prevOpen === filters) return null
        return filters
      })
    }
  }

  const handleFilterMobileDialog = (back: boolean) => {
    back ? handleCloseSubDialog() : handleCloseDialog()
  }

  const handleCloseDialog = () => {
		lastUrl ? router.push(lastUrl).then(() => {
				skipResult(false)
    		setFilterDialogMobileOpen(false)
				setLastUrl(null)
		}) : skipResult(false); setFilterDialogMobileOpen(false); setLastUrl(null);
  }

  const handleCloseSubDialog = () => {
    setFilterMobileSubmenuDialogOpen(null)
    setFilterMobileSubmenuDialogTitle(null)
    setFilterMobileSubmenuDialogSubtitle(null)
  }

  const handleCloseSubmenu = () => {
    setFilterMobileSubmenuOpen(null)
  }

  const handleCloseAll = () => {
    isSkipResult ? skipResult(false) : null
    setSortOrderMobileOpen(false)
    setFilterDialogMobileOpen(false)
    setFilterMobileSubmenuOpen(null)
    setFilterMobileSubmenuDialogOpen(null)
    setFilterMobileSubmenuDialogTitle(null)
    setFilterMobileSubmenuDialogSubtitle(null)
  }

  return (
    <>
      <FindFloatingButton
        variant="extended"
        disableFocusRipple
        disableTouchRipple
        disableRipple
        bgcolor={colors.mainColor}
      >
        <Grid container flexWrap={'nowrap'}>
          <Grid item>
            <Stack component={'a'} onClick={() => toggleFilters(true)}>
              <Grid container flexWrap={'nowrap'} alignItems={'center'} justifyContent={'center'}>
                <Grid item mr={0.5}>
                  <FilterAltIcon />
                </Grid>
                <Grid item>{t('web.listing.mobilSzures.szuroTitle')}</Grid>
              </Grid>
            </Stack>
          </Grid>
          <Divider orientation="vertical" flexItem />
          <Grid item alignSelf={'center'}>
            <Stack component={'a'} onClick={toggleSortOrder(true)}>
              <Grid container flexWrap={'nowrap'} alignItems={'center'} justifyContent={'center'}>
                <Grid item mr={0.5}>
                  <FormatLineSpacingIcon />
                </Grid>
                <Grid item>{t('web.listing.mobilSzures.rendezesTitle')}</Grid>
              </Grid>
            </Stack>
          </Grid>
        </Grid>
      </FindFloatingButton>

      <FindSwipeableDrawer
        anchor={'bottom'}
        open={sortOrderMobileOpen}
        onClose={toggleSortOrder(false)}
        onOpen={toggleSortOrder(true)}
      >
        <Stack>
          <FindFilterTitle textAlign={'center'} m={2}>
            {t('web.listing.mobilSzures.rendezesTitle')}
          </FindFilterTitle>
          <FindMobileLink
            color={colors.mainColor}
            right={15}
            top={type === PageType.RBhuPP ? 17 : 23}
            onClick={toggleSortOrder(false)}
          >
            {t('web.listing.mobilSzures.keszButtonText')}
          </FindMobileLink>
        </Stack>
        <Stack>
          <List disablePadding>
            {bazarItems?.sortOrders?.map((item, i) => (
              <Stack key={i}>
                <ListItem disablePadding>
                  <Link
                    href={
                      ((pageUrl && pageUrl !== '/' ? pageUrl + item.url : item.url) +
                        (type !== PageType.RBhuPP && mmbr
                          ? item.url?.includes('?')
                            ? `&mmbr=${mmbr}`
                            : `?mmbr=${mmbr}`
                          : '')) as string
                    }
                  >
                    <FindMobileListItemButton selected={item.title == sortOrder?.title} selectedcolor={colors.mainColor} onClick={() => setSortOrder(item)}>
                      <ListItemIcon>
                        <Radio name="sortOrder" checked={item.title == sortOrder?.title} disableFocusRipple disableRipple disableTouchRipple />
                      </ListItemIcon>
                      <ListItemText primary={item.title} />
                    </FindMobileListItemButton>
                  </Link>
                </ListItem>
                <Divider />
              </Stack>
            ))}
          </List>
        </Stack>
      </FindSwipeableDrawer>

      <FindFullScreenDialog open={filterDialogMobileOpen} fullScreen scroll={'paper'}>
        <Stack flexDirection={'row'} justifyContent={'center'}>
          <FindMobileLink
            position={'absolute'}
            left={15}
            top={19}
            color={colors.mainColor}
            onClick={() => handleFilterMobileDialog(filterMobileSubmenuDialogOpen !== null)}
          >
            {filterMobileSubmenuDialogOpen !== null ? <KeyboardArrowLeftIcon /> : <CloseIcon />}
          </FindMobileLink>
          <FindFilterTitle textAlign={'center'} m={2} display={'flex'} flexDirection={'column'}>
            {t('web.listing.mobilSzures.szuroTitle')}
            {filterMobileSubmenuDialogOpen !== null ? (
              <Typography component={'span'} fontSize={'14px'}>
                {filterMobileSubmenuDialogTitle} {filterMobileSubmenuDialogSubtitle}
              </Typography>
            ) : null}
          </FindFilterTitle>
          <Link href={pageUrl as string}>
            <FindMobileLink position={'absolute'} right={10} top={type === PageType.RBhuPP ? 17 : 22} color={colors.mainColor}>
              {t('web.listing.mobilSzures.visszaallitasButtonText')}
            </FindMobileLink>
          </Link>
        </Stack>
        <FindFullScreenDialogContent>
          <Stack>
            {filterMobileSubmenuDialogOpen !== null ? (
              <FindMobileFilterList>
                {getFilterType(
                  filterMobileSubmenuDialogOpen as ResultFilterModel,
                  colors,
                  pageUrl,
                  mmbr,
                  isMobile,
                  handleCloseSubDialog
                )}
              </FindMobileFilterList>
            ) : (
              <FindMobileFilterList>
                {bazarItems?.resultFilters?.map((filters, i) => {
                  const selectedItems = filters?.items?.filter((i) => i.selected).map((i) => capitalize(i.title as string)).join(', ')
                  
                  switch (filters.uiMode) {
                    case ResultFilterUIMode.FindQuery:
                      return (
                        <Stack key={i}>
                          {getFilterType(filters, colors, pageUrl, mmbr, isMobile)}
                          <Divider />
                        </Stack>
                      )
                      break
                    case ResultFilterUIMode.CheckBox:
                      return (
                        <Stack key={i}>
                          <ListItem secondaryAction={getFilterType(filters, colors, pageUrl, mmbr, isMobile)}>
                            <ListItemText>
                              <Typography sx={{ fontSize: 'inherit' }}>{filters.title}</Typography>
                            </ListItemText>
                          </ListItem>
                          <Divider />
                        </Stack>
                      )
                      break
                    case ResultFilterUIMode.UjVagyHasznalt:
                      return (
                        <Stack key={i}>
                          <Stack my={2}>{getFilterType(filters, colors, pageUrl, mmbr, isMobile)}</Stack>
                          <Divider />
                        </Stack>
                      )
                    default:
                      return (
                        <Stack key={i}>
                          <ListItem
                            secondaryAction={
                              filterMobileSubmenuOpen === filters ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />
                            }
                            onClick={() =>
                              handleFilterMobileSubmenu(filters)
                            }
                          >
                            <ListItemText>
                              <Typography sx={{ fontSize: 'inherit' }}>{filters.title}</Typography>
                            </ListItemText>
                            <ListItemText sx={{ textAlign: 'right' }}>
                              {selectedItems}
                            </ListItemText>
                          </ListItem>
                          <Collapse in={filterMobileSubmenuOpen === filters} timeout="auto" unmountOnExit>
                            <Divider />
                            <List component="div" disablePadding>
                              {getFilterType(filters, colors, pageUrl, mmbr, isMobile, handleCloseSubmenu)}
                            </List>
                          </Collapse>
                          <Divider />
                        </Stack>
                      )
                  }
                })}
              </FindMobileFilterList>
            )}
          </Stack>
        </FindFullScreenDialogContent>
        <FindFullScreenDialogActions>
          <FindButton
            onClick={() => handleCloseAll()}
            bgcolor={colors.mainColor}
            bghovercolor={colors.secondaryColor}
            variant="contained"
            conditionbutton={1}
            sx={{ width: '100%', height: '50px' }}
          >
            {t('web.listing.mobilSzures.keresesButtonText', { adCount: bazarItems?.foundCount?.toLocaleString('hu') })}
          </FindButton>
        </FindFullScreenDialogActions>
      </FindFullScreenDialog>
    </>
  )
}

export default FindFilterMobileBlock
